import { Injectable } from "@angular/core";
import { AuthService } from "../../auth/services/auth.service";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class LoggingService {
  private logsUrl: string = environment.logsUrl;
  private isLoggingInProgress = false; // avoid recursive calls

  constructor(private authService: AuthService, private http: HttpClient) {}

  async logEvent(
    eventType: string,
    additionalData: Record<string, any> = {}
  ): Promise<void> {
    if (!environment.enableLogging || this.isLoggingInProgress) {
      return;
    }

    this.isLoggingInProgress = true;

    const eventTimestamp = new Date().toISOString();
    let user_id = "unknown";
    let username = "unknown";

    try {
      const decodedToken = await this.authService.getDecodedToken();
      user_id = decodedToken.sub;
      username = decodedToken.preferred_username || "unknown";
    } catch (error) {
      console.warn("Failed to retrieve user_id:", error);
    }

    const logEntry = {
      //'@timestamp': eventTimestamp,//added by java LogstashEncoder
      service_name: "service_registry",
      event_type: eventType,
      user_id,
      username,
      ...additionalData,
    };

    this.http
      .post(this.logsUrl, logEntry, {
        headers: { "X-Log-Request": "true" },
      })
      .subscribe({
        next: () => {},
        error: (err: any) => console.error("Log send failed:", err),
        complete: () => {
          this.isLoggingInProgress = false;
        },
      });
  }
}
